/**
 * @file: channels.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * Which follow-up channels the screen offers and which outcomes make sense per
 * channel. Tweak the lists here to change what each channel surfaces; an
 * out-of-set outcome is cleared when the channel changes.
 */

import { LeadActivityOutcome } from '@euler/model/lead/LeadActivity';

// The channels a follow-up can be logged through (the `system` channel is
// machine-authored and never offered here).
export const kChannels = [
  'phone',
  'wechat',
  'sms',
  'in_person',
  'note',
] as const;
export type SelectableChannel = (typeof kChannels)[number];

// A 微信 follow-up can't go 未接听, a 备注 has no outcome at all.
export const kOutcomesByChannel: Record<
  SelectableChannel,
  LeadActivityOutcome[]
> = {
  // Sync call — the full set incl. 约定回电 / 已拒接 / 未接听.
  phone: [
    'reached_booked',
    'reached_declined',
    'considering',
    'postponed',
    'callback_requested',
    'no_answer',
    'call_rejected',
    'unreachable',
    'wrong_number',
    'other',
  ],
  // Async message — no "未接听" / "约定回电"; instead 未回复, and 发送失败 (blocked).
  wechat: [
    'reached_booked',
    'reached_declined',
    'considering',
    'postponed',
    'no_reply',
    'send_failed',
    'other',
  ],
  sms: [
    'reached_booked',
    'reached_declined',
    'considering',
    'postponed',
    'no_reply',
    'wrong_number',
    'other',
  ],
  in_person: [
    'reached_booked',
    'reached_declined',
    'considering',
    'postponed',
    'other',
  ],
  note: [],
};
